import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { MeterModelPatch, MeterModelRequest } from '../../../../pages/meters/meters.model'
import { UseModelPatch } from '../../../../pages/uses/uses.model'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { CancelMeterModel, MeterModel, UseModel } from '../../model/contracts'

export const apiPostMeter = async (
  newMeter: MeterModelRequest,
  cupsID: number
): Promise<MeterModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = newMeter
  return await AxiosInstance.post(
    // `https://localhost:59923/api/Meters/cups(${cupsID})`,
    `${apiSuffixUrl}/api/Meters/cups(${cupsID})`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiPatchMeter = async (modifiedMeter: MeterModelPatch): Promise<MeterModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = modifiedMeter

  return await AxiosInstance.patch(
    // `https://localhost:59923/api/Meters`,
    `${apiSuffixUrl}/api/Meters`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiPostCancelMeter = async (cancelMeter: CancelMeterModel): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = cancelMeter
  return await AxiosInstance.post(
    // `https://localhost:59923/api/Meters/CancelMeter`,
    `${apiSuffixUrl}/api/Meters/CancelMeter`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiDeleteMeter = async (meterID: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    // `https://localhost:59923/api/Meters(${meterID})`
    `${apiSuffixUrl}/api/Meters(${meterID})`
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiPostUseFromMeter = async (newUse: UseModel, meterID: number): Promise<UseModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = newUse

  return await AxiosInstance.post(
    // `https://localhost:59923/api/Meters(${meterID})/Uses`,
    `${apiSuffixUrl}/api/Meters(${meterID})/Uses`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiDeleteUseFromMeter = async (useID: number, meterID: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    // `https://localhost:59923/api/Meters(${meterID})/Uses(${useID})`
    `${apiSuffixUrl}/api/Meters(${meterID})/Uses(${useID})`
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiPatchUseFromMeter = async (
  modifieduse: UseModelPatch,
  meterID: number
): Promise<UseModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = modifieduse

  return await AxiosInstance.patch(
    // `https://localhost:59923/api/Meters(${meterID})/Uses(${modifieduse.id})`,
    `${apiSuffixUrl}/api/Meters(${meterID})/Uses(${modifieduse.id})`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}
